module.exports = "/packs/images/products/fruit-46e55363fbe9e9036e31cdc2867fa3f7.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/images/products/fruit.jpg
// module id = 734
// module chunks = 0 1 2 4